import { getAppName, getEnvironmentVariableByName } from "./envs.utils";

export const STORAGE_BASE_PATH =
  getEnvironmentVariableByName("STORAGE_BASE_PATH");
export const IMAGES_FOLDER = "images";
export const DOCUMENTS_FOLDER = "documents";

const URL_REGEX = /^https?:\/\/|^\/\//i;

export const isAbsoluteUrl = (url: string) => {
  const test = URL_REGEX.test(url);
  return test;
};

export const buildStorageUrl = (url: string) => {
  const isAbsolute = isAbsoluteUrl(url);
  if (isAbsolute) {
    return url;
  }
  const startsWithSlash = url.startsWith("/");
  const APP_NAME = getAppName();
  if (startsWithSlash) {
    return `${STORAGE_BASE_PATH}/${APP_NAME}${url}`;
  }
  return `${STORAGE_BASE_PATH}/${APP_NAME}/${url}`;
};

export const getStorageUrlData = (url: string) => {
  const isAbsolute = isAbsoluteUrl(url);
  return {
    isAbsolute,
    url: buildStorageUrl(url),
  };
};

export const triggerDownloadFileFromByteArray = (
  fileName: string,
  data: Iterable<number>,
) => {
  return new Promise((resolve, reject) => {
    try {
      const blob = new Blob([new Uint8Array(data)], {
        type: "application/octet-stream",
      });
      const link = window.document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      return resolve(true);
    } catch (e) {
      return reject(e as Error);
    }
  });
};
